import template from './sw-cms-preview-jga-revocation-button.html.twig';

export default {
    template,
};
